import styled from 'styled-components';

export const List = styled.ul(
  () => `
    flex: 1;
    margin: 0;
    padding: 0;
  `,
);
